export const SET_FILTERS = 'SET_FILTERS';
export const SET_APPS_FILTERS = 'SET_APPS_FILTERS';

export const FETCH_PAGE_DATA_REQUEST = 'FETCH_PAGE_DATA_REQUEST';
export const FETCH_PAGE_DATA_SUCCESS = 'FETCH_PAGE_DATA_SUCCESS';
export const FETCH_PAGE_DATA_FAILURE = 'FETCH_PAGE_DATA_FAILURE';

export const FETCH_APPS_REQUEST = 'FETCH_APPS_REQUEST';
export const FETCH_APPS_SUCCESS = 'FETCH_APPS_SUCCESS';
export const FETCH_APPS_FAILURE = 'FETCH_APPS_FAILURE';
